import { createContext, useContext, useMemo } from 'react'
import { useMenu } from '../../hooks/menu'
import { name as laggySwrMiddlewareName } from '../../stale-while-revalidate/middlewares/laggy'
import { useConfig } from '../config'

const MenusContext = createContext()

const MenusProvider = ({ children }) => {
	const { menus } = useConfig()

	const { menu: mainMenu } = useMenu({ code: menus?.top?.code, options: { bhUse: [laggySwrMiddlewareName] } })
	const { menu: footerMenu } = useMenu({ code: menus?.bottom?.code, options: { bhUse: [laggySwrMiddlewareName] } })

	const contextValue = useMemo(() => ({ mainMenu, footerMenu }), [mainMenu, footerMenu])

	return <MenusContext.Provider value={contextValue}>{children}</MenusContext.Provider>
}

export default MenusProvider
export const useMenus = () => useContext(MenusContext)
